import * as React from "react";

const SvgInfoIcon = (props) => (
  <svg
    width={19}
    height={19}
    fill="#283d57"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx={9.5} cy={9.5} r={9} stroke="#DDDDDD" />
    <path
      d="M9.007 13.454V7.623h.984v5.831h-.984Zm.504-7.031a.718.718 0 0 1-.492-.18.598.598 0 0 1-.192-.456c0-.192.064-.344.192-.456.136-.12.3-.18.492-.18s.352.06.48.18a.56.56 0 0 1 .204.456.582.582 0 0 1-.204.456.675.675 0 0 1-.48.18Z"
      fill="#FFFFFF"
    />
  </svg>
);

export default SvgInfoIcon;
